import './Home.css';
import pdftojpg from './Pics/pdftojpg.jpg';
import jpgtopdf from './Pics/jpegtopdf.jpg';
import imgrisizer from './Pics/image resizer.png';
let Home =()=>{

    let PicArray = ["https://makeeasyway.in/static/media/res3.53630fb55a086a678e08.png",pdftojpg,jpgtopdf,imgrisizer]



    return(
        <div className='homemaincont'>
            <div className='aboutresumecont'>
                <div className='resumedesignspics same'>
                    <img  alt='photo1' className='imgresdes' src={PicArray[0]}/>
                </div>
                <div className='aboutresumedesignespics same'>
                    <li>Make Resume Faster Batter and Easier way.</li>
                    <p style={{padding:"18px", fontSize:"20px"}}>
                        Here you can make resume as you want. 
                        make resumes for school , offices, jobs and many more.

                    </p>
                  
                </div>
            </div> 
            <div className='aboutresumecont'>
                <div className='resumedesignspics same'>
                    <img  alt='photo2' className='imgresdes' src={PicArray[1]}/>
                </div>
                <div className='aboutresumedesignespics same'>
                    <li>Pdf to jpeg convert Faster</li>
                   <p style={{padding:"18px", fontSize:"20px"}}>
                        You can convert pdf to jpg in actual clearity and resolution try it now...
                        <a href='/Converter'>Click here</a>

                    </p>
                </div>
                
            </div> 
            <div className='aboutresumecont'>
                <div className='resumedesignspics same'>
                    <img  alt='photo3' className='imgresdes' src={PicArray[2]}/>
                </div>
                <div className='aboutresumedesignespics same'>
                    <li>jpeg to pdf convert Easier and Faster</li>
                    <p style={{padding:"18px", fontSize:"20px"}}>
                        You can convert JPG to PDF in actual clearity and resolution try it now...
                        <a href='/Converter'>Click here</a>

                    </p>
                    
                </div>
            </div> 
             <div className='aboutresumecont'>
                <div className='resumedesignspics same'>
                    <img alt='photo4' className='imgresdes' src={PicArray[3]}/>
                </div> 
                <div className='aboutresumedesignespics same'>
                    <li>Image Resizer</li>
                    <p style={{padding:"18px", fontSize:"20px"}}>
                        You can resize images in actual clearity and different types of resolutions try it now...
                        <a href='/Converter'>Click here</a>

                    </p>
                </div>
            </div> 
        </div>
    );
}   

export default Home;